import React from "react";

export default function Privacy() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate">
        <div className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0052FF]">Privacy Policy</div>
        <h1 className="mt-2 font-display text-4xl font-bold tracking-tight text-[#06152D]">Privacy Policy</h1>
        <p className="mt-4 text-[#52525B]">Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" })}</p>

        <div className="mt-8 space-y-6 text-[#09090b]">
          <div>
            <h2 className="font-display text-xl font-bold text-[#06152D]">1. About this policy</h2>
            <p className="mt-2 text-[#52525B] leading-relaxed">
              This Privacy Policy explains how Loan Junction Finance Services ("Loan Junction", "we", "us") collects, uses, discloses,
              and safeguards personal information you provide when you apply for a loan or use our services.
            </p>
          </div>
          <div>
            <h2 className="font-display text-xl font-bold text-[#06152D]">2. Information we collect</h2>
            <ul className="mt-2 text-[#52525B] list-disc pl-6 space-y-1">
              <li>Contact details — full name, phone, email, address</li>
              <li>KYC data — Aadhaar, PAN, photograph (used solely for loan submission to partner banks/NBFCs)</li>
              <li>Financial data — income, employment, bank statements, existing obligations</li>
              <li>Loan/insurance-specific documents you upload</li>
            </ul>
          </div>
          <div>
            <h2 className="font-display text-xl font-bold text-[#06152D]">3. How we use it</h2>
            <p className="mt-2 text-[#52525B] leading-relaxed">To evaluate your enquiry, submit applications to appropriate partner Banks/NBFCs on your behalf, and provide follow-up communication (calls, WhatsApp, email). We do not sell your information.</p>
          </div>
          <div>
            <h2 className="font-display text-xl font-bold text-[#06152D]">4. Sharing</h2>
            <p className="mt-2 text-[#52525B] leading-relaxed">We share your information only with the partner Bank/NBFC to which you have consented to submit your loan or insurance application. We may also share it with regulators, auditors, or law-enforcement when legally required.</p>
          </div>
          <div>
            <h2 className="font-display text-xl font-bold text-[#06152D]">5. Data security</h2>
            <p className="mt-2 text-[#52525B] leading-relaxed">Sensitive documents are stored on encrypted object storage with role-based access. Only assigned employees can view a customer's file. All privileged actions are audit-logged.</p>
          </div>
          <div>
            <h2 className="font-display text-xl font-bold text-[#06152D]">6. Your rights</h2>
            <p className="mt-2 text-[#52525B] leading-relaxed">You may request a copy of the data we hold about you, ask for corrections, or ask us to delete it (subject to statutory retention requirements). Write to <a className="text-[#0052FF] underline" href="mailto:loanhub929@gmail.com">loanhub929@gmail.com</a>.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
